import React, { FC } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface ReliabilityECommerceProps {
  eCommerceData: any
}

const ReliabilityECommerce: FC<ReliabilityECommerceProps> = ({ eCommerceData }) => {
  const ref = React.useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.2 })

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  }

  return (
    <motion.div
      ref={ref}
      variants={containerVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12 lg:gap-16 p-6 md:p-12 lg:p-20 pt-16 px-4 md:px-8 lg:px-36'
    >
      {eCommerceData.ReliabilityECommerceData.map((reliable: any, index: number) => {
         let img = getImage(reliable.image ?? "") ?? "";
        return (
          <motion.div
            key={index}
            variants={cardVariants}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300, damping: 15 }}
          >
            <motion.div 
              className='relative p-[1px] flex rounded-3xl hover:border-none border-2 border-[#2F2F2F]'
              whileHover={{
               backgroundImage: `linear-gradient(354.61deg, ${reliable.bgColor} -38.83%, rgba(255, 185, 18, 0) 91.93%)`
              }}
              transition={{ duration: 0.3 }}
            >
              <div className='bg-darkGreyPrimary p-6 md:p-8 pt-16 md:pt-16 rounded-3xl'>
                <motion.div
                  className="absolute -top-8 w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center left-8 md:left-14 bg-[#222222]"
                  // style={{ background: `${reliable.bgColor}` }}
                  whileHover={{ scale: 1.1, background:`${reliable.bgColor}` }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  <div className='flex items-center justify-center text-black font-black text-lg md:text-xl'>
                    <DynamicSVG color='#fff' size='w-4/5'>{img}</DynamicSVG>
                  </div>
                </motion.div>
                <div className='flex flex-col gap-1'>
                  <span className={`text-lg md:text-xl font-medium text-white`}>
                    <b>{reliable.title}:</b>
                  </span>
                  <span className='text-sm md:text-base'>
                    {reliable.subtitle}
                  </span>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )
      })}
    </motion.div>
  )
}

export default ReliabilityECommerce
